// extracted by mini-css-extract-plugin
module.exports = {"root":"detail_root__1NEI2","inline":"detail_inline__kNS_2","iconed":"detail_iconed__c7W19"};